import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Products from "./components/Products";
import Portfolio from "./components/Portfolio";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import PortfolioAssistant from "./components/PortfolioAssistant";
import { PortfolioDataProvider, usePortfolioData } from "./context/PortfolioDataContext";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function PortfolioContent() {
  const { loading, error } = usePortfolioData();
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('portfolio-theme') || 'new-theme';
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const newTheme = localStorage.getItem('portfolio-theme') || 'old-theme';
      setTheme(newTheme);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const isNewTheme = theme === 'new-theme';

  if (loading) {
    return (
      <main className="min-h-screen bg-gray-900 flex items-center justify-center">
        <LoadingSpinner />
      </main>
    );
  }

  if (error) {
    return (
      <main className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
        <p className="text-gray-400 text-center max-w-md">
          Unable to load portfolio content. Please refresh the page.
        </p>
      </main>
    );
  }

  return (
    <main className={isNewTheme ? "bg-gray-900 text-gray-100" : "bg-white text-gray-900"}>
      <Navbar />
      <div id="hero">
        <Hero />
      </div>
      <Services />
      <Products />
      <Testimonials />
      <Portfolio />
      <Contact />
      <Footer />
      <PortfolioAssistant />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={isNewTheme ? "dark" : "light"}
      />
    </main>
  );
}

function LoadingSpinner() {
  return (
    <div className="flex flex-col items-center gap-4" role="status" aria-label="Loading portfolio">
      <div className="relative h-14 w-14">
        <div className="absolute inset-0 rounded-full border-2 border-primary-800" />
        <div className="absolute inset-0 rounded-full border-2 border-primary-400 border-t-transparent animate-spin" />
        <div className="absolute inset-2 rounded-full bg-primary-500/20 animate-pulse" />
      </div>
      <p className="text-sm text-gray-400 animate-pulse">Initializing AI portfolio...</p>
    </div>
  );
}

export default function App() {
  return (
    <PortfolioDataProvider>
      <PortfolioContent />
    </PortfolioDataProvider>
  );
}
